import { Component, OnInit, Input } from '@angular/core';
import { DVFormGroup } from '../dynamic-validator';

@Component({
  selector: 'app-dverror',
  templateUrl: './dverror.component.html',
  styleUrls: ['./dverror.component.css']
})
export class DVErrorComponent {

  @Input() parentFormGroup: DVFormGroup;
  @Input() fieldName: string;

}
